var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-core__header__right coreRight" }, [
    _c("div", { staticClass: "emd-drawer _right" }, [
      _c(
        "div",
        {
          staticClass: "emd-drawer__trigger coreRight-trigger",
          class: { _open: _vm.isOpen },
        },
        [
          _c(
            "button",
            {
              staticClass: "emd-action-button",
              on: { click: _vm.toggleDrawerMenu },
            },
            [
              _c("i", {
                staticClass: "uil uil-ellipsis-v emd-action-button__icon",
              }),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "coreRight-content",
          class: { _open: _vm.isOpen, "coreRight-content__open": _vm.isOpen },
        },
        [
          _vm.canShowPix || _vm.canShowAppsList
            ? _c("emd-dropdown", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function () {
                        return [
                          _c("div", [
                            _c(
                              "ul",
                              _vm._l(_vm.popoverItems, function (item) {
                                return _c("li", { key: item.title }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "coreRight-items",
                                      on: { click: item.action },
                                    },
                                    [_vm._v(" " + _vm._s(item.title) + " ")]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2263374608
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }